const SkeletonTournamentCard = () => {
  return (
    <div className="flex items-center justify-between bg-gray-900 text-white p-4 rounded-lg w-full max-w-2xl animate-pulse">

      {/* Left Section Skeleton */}
      <div className="flex flex-col space-y-2">
        <div className="h-3 w-20 bg-gray-700 rounded"></div>
        <div className="h-5 w-12 bg-gray-600 rounded"></div>
      </div>

      {/* Center Section Skeleton */}
      <div className="flex flex-col items-center space-y-2">
        <div className="h-4 w-32 bg-gray-700 rounded"></div>

        <div className="flex items-center space-x-2">
          <div className="h-3 w-6 bg-gray-600 rounded"></div>
          <div className="h-3 w-3 bg-gray-600 rounded-full"></div>
          <div className="h-3 w-20 bg-gray-600 rounded"></div>
        </div>
      </div>

      {/* Right Section Skeleton */}
      <div>
        <div className="h-10 w-28 bg-gray-700 rounded-md"></div>
      </div>

    </div>
  );
};

export default SkeletonTournamentCard;